import { useCallback, useEffect, useRef, useState } from 'react'
import { useUnmount } from 'react-use'
import { off, on } from '../../../lib/events'
import { TaskOperations } from '../../../types'

export function useResetPage(operations?: TaskOperations[]): boolean {
  const timeoutRef = useRef<any>(null)
  const [resetPage, setResetPage] = useState(false)
  const [expectedOperationId, setExpectedOperationId] = useState<string | null>(
    null
  )

  const onResetPage = useCallback((event: any) => {
    setExpectedOperationId(event.detail?.operationId)
    setResetPage(true)

    // If the operationId is not present, resets the page in 200ms; otherwise,
    // wait for the operation to be created before resetting the page
    if (!event.detail?.operationId) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => setResetPage(false), 200)
    }
  }, [])

  useEffect(() => {
    on('player:reset-page', onResetPage)
    return () => off('player:reset-page', onResetPage)
  }, [onResetPage])

  // Here is where we wait for the operation to be created before resetting the
  // page
  useEffect(() => {
    if (!resetPage || !expectedOperationId) {
      return
    }

    const operationExists = operations?.some(
      (op) => op.id === expectedOperationId
    )

    if (operationExists) {
      setResetPage(false)
    }
  }, [expectedOperationId, operations, resetPage])

  useUnmount(() => clearTimeout(timeoutRef.current))

  return resetPage
}
